<template>
  <div>
    <h1>
      Air Quality - Electronic Site Management Portal
    </h1>
    <p>
      Welcome to the Cook County Department of Environment and Sustainability electronic site management portal. With this portal
      you can:
      <ul>
        <li>Pay Annual Invoices</li>
        <li>Register New Equipment &amp; Pay Installation Permit Fee</li>
        <li>Decommission Active Equipment</li>
        <li>Retrieve past Invoice Documents</li>
      </ul>
    </p>
    <p>To get started, please sign into your site</p>
    <div class="row justify-content-left">
      <div class="col-6 col-md-6">
        <a @click="signIn" style="color: white; cursor: pointer;" class="btn btn-primary btn-block">
          Site Sign In
        </a>
      </div>
    </div>
    <br />
    <!--
    <p style="color:red">NOTE: The Certificate of Operation (COO) payment deadline has passed.  If you have not paid for your 2020 COO, your account balance will be adjudicated by the Cook County Dept of Administrative Hearings.  A notification/citation will be sent to your facility with further instructions.</p>
    -->
    <!--
    <p>To get started, please log in or register a new site.</p>
    <div class="row justify-content-around">
      <div class="col-12 col-md mt-3">
        <p>For <strong>registered users</strong></p>
        <a :href="loginUrl" class="btn btn-primary btn-block">
          Login
        </a>
      </div>
      <div class="col-12 col-md mt-3">
        <p>For <strong>first time users</strong></p>
        <a :href="registerUrl" class="btn btn-primary btn-block">
          Create a New Account
        </a>
      </div>
    </div>
    -->
  </div>
</template>

<script>

import { getLandingCallback, errorNotification } from '~/js/FormFunctions';

export default {
  name: 'AirQualityLanding',
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
    };
  },
  mounted() {
    getLandingCallback()
      .then((data) => {
        this.registerUrl = `http://10.122.78.13/OneCookCounty/Account/Register?returnUrl=${data}`;
        this.loginUrl = `http://10.122.78.13/OneCookCounty/Account/Login?returnUrl=${data}`;
      }).catch((error) => {
        errorNotification('Error Getting Landing Callback');
      });
  },
  methods: {
    signIn() {
      this.$router.push({ name: 'SiteAuthentication', query: this.$route.query });
    },
  },
};

</script>
